const ADMIN = 'Administrator';
const EVANGELIST = 'Evangelist';
const SENIOR_PASTOR = 'SeniorPastor';
const PASTOR = 'Pastor';

export const ROLES = {
  admin: ADMIN,
  evangelist: EVANGELIST,
  seniorPastor: SENIOR_PASTOR,
  pastor: PASTOR
};

export const ROLE_SETS = {
  admins: [ADMIN],
  pastors: [SENIOR_PASTOR, PASTOR],
  churchManagers: [EVANGELIST, SENIOR_PASTOR, PASTOR],
  churchTopManagers: [EVANGELIST, SENIOR_PASTOR],
  all: [ADMIN, EVANGELIST, SENIOR_PASTOR, PASTOR]
};



// WEBPACK FOOTER //
// ./src/components/authorization/roles.js